/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTimeEntryResponse
 */
export interface CreateTimeEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTimeEntryResponse
     */
    timeEntryIds: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof CreateTimeEntryResponse
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateTimeEntryResponse
     */
    timeWorked: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryResponse
     */
    labourCodeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryResponse
     */
    billingRoleId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryResponse
     */
    billingStatus: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTimeEntryResponse
     */
    warnings: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryResponse
     */
    statusId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryResponse
     */
    statusName: string;
}

/**
 * Check if a given object implements the CreateTimeEntryResponse interface.
 */
export function instanceOfCreateTimeEntryResponse(value: object): value is CreateTimeEntryResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('timeEntryIds' in value) || value['timeEntryIds'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('timeWorked' in value) || value['timeWorked'] === undefined) return false;
    if (!('labourCodeId' in value) || value['labourCodeId'] === undefined) return false;
    if (!('billingRoleId' in value) || value['billingRoleId'] === undefined) return false;
    if (!('billingStatus' in value) || value['billingStatus'] === undefined) return false;
    if (!('warnings' in value) || value['warnings'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('statusName' in value) || value['statusName'] === undefined) return false;
    return true;
}

export function CreateTimeEntryResponseFromJSON(json: any): CreateTimeEntryResponse {
    return CreateTimeEntryResponseFromJSONTyped(json, false);
}

export function CreateTimeEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTimeEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'timeEntryIds': json['timeEntryIds'],
        'date': (new Date(json['date'])),
        'timeWorked': json['timeWorked'],
        'labourCodeId': json['labourCodeId'],
        'billingRoleId': json['billingRoleId'],
        'billingStatus': json['billingStatus'],
        'warnings': json['warnings'],
        'statusId': json['statusId'],
        'statusName': json['statusName'],
    };
}

export function CreateTimeEntryResponseToJSON(value?: CreateTimeEntryResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'timeEntryIds': value['timeEntryIds'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'timeWorked': value['timeWorked'],
        'labourCodeId': value['labourCodeId'],
        'billingRoleId': value['billingRoleId'],
        'billingStatus': value['billingStatus'],
        'warnings': value['warnings'],
        'statusId': value['statusId'],
        'statusName': value['statusName'],
    };
}

